import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

import type { AvailableLanguage } from './types';

const RootProviders = lazy(() => import('@app/components/AppProviders'));
const LanguageSettings = lazy(() =>
    import('./LanguageSettings').then((module) => ({ default: module.LanguageSettings })),
);

class LanguageSettingsWebComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['available-langs', 'selected-lang'];
    }

    render() {
        const availableLanguages = this.jsonProp<AvailableLanguage[]>('available-langs') || [];
        const selectedLanguage = this.jsonProp<AvailableLanguage>('selected-lang');

        return (
            <RootProviders>
                <LanguageSettings initialSelectedLanguage={selectedLanguage} availableLanguages={availableLanguages} />
            </RootProviders>
        );
    }
}

customElements.define('language-settings', LanguageSettingsWebComponent);
